module.exports = __webpack_public_path__ + "img/main_right4.b04557de.png";